import React from 'react';

import { Skeleton, TableRow, TableCell, styled } from '@mui/material';

const StyledTableCell = styled(TableCell)`
    padding: 0.716rem 1rem;
`;

const LoadingTableRows: React.FC = () => {
    const tableRows: any[] = [];

    for (let i = 0; i < 15; i++) {
        tableRows.push(
            <TableRow key={i}>
                <StyledTableCell>{<Skeleton animation="wave" />}</StyledTableCell>
                <StyledTableCell>{<Skeleton animation="wave" />}</StyledTableCell>
                <StyledTableCell>{<Skeleton animation="wave" />}</StyledTableCell>
                <StyledTableCell>{<Skeleton animation="wave" />}</StyledTableCell>
            </TableRow>
        );
    }

    return <>{tableRows}</>;
};

export default LoadingTableRows;
